import React, { useState, useEffect } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import TR from './../../Trans';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as EqualizerIcon } from './../../assets/equalizer.svg';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import IntervalService from './../../services/intervals';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import RemoveFavorite from '../dialogs/RemoveFavorite';
import settingsStore from '../../stores/settings';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from '../../stores/favorites';
import playerStore from '../../stores/player';

function PerformanceSongPosition(props) {

  const isPlaying = playerStore((state) => state.isPlaying);
  const currentPerformance = performanceStore((state) => state.currentPerformance);

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const currentPosition = () => {
    return props.performance.position;
  };

  const primaryText = () => {
    if (props.performance.track) {
      if (props.performance.profile) {
        return (currentPosition() + 1) + ". " + props.performance.profile.name + " - " + props.performance.track.title;
      } else {
        return (currentPosition() + 1) + ". " + props.performance.track.title;
      }
    }
  };

  const isSelectedClass = () => {
    if (props.performanceInitial || props.performanceInitial == 0) {
      if (props.performanceInitial === currentPosition()) {
        return "muvika-song-position-selected";
      }
    }
    if (props.performanceSelected || props.performanceSelected == 0) {
      if (props.performanceSelected === currentPosition()) {
        return "muvika-song-position-selected";
      }
    }
    return "muvika-song-position-hovering";
  };

  const showIcon = () => {
    if (isPlaying.isPlaying) {
      return <SvgIcon className="muvika-icon performance-list-item-icon" component={EqualizerIcon} />;
    } else {
      return <PlayArrowIcon className="muvika-track-play-icon" />;
    }
  };

  const renderAvatar = () => {
    if (currentPerformance?.unique_id === props.performance.unique_id) {
      return <ListItemAvatar className="muvika-track-avatar-item">
        <Avatar className="muvika-track-avatar">
          {showIcon()}
          <img className="muvika-track-avatar-image" src={props.performance.track.url_thumb_image} alt="" />
        </Avatar>
      </ListItemAvatar>;
    }
  };

  const secondaryText = props.performance.track ? props.performance.track.artist : "";

  return (
    <ListItemButton id={props.id} className={isSelectedClass()} onClick={props.onChoosePosition}>
      {renderAvatar()}
      <ListItemText primary={primaryText()} secondary={secondaryText} />
    </ListItemButton>
  );
};

export default PerformanceSongPosition;